export enum MonacoEditorLanguage {
  Typescript = 'typescript',
  Javascript = 'javascript',
  Json = 'json',
  Css = 'css',
  Python = 'python',
  NodeJS = 'nodejs'
}
